document.title = import.meta.env.VITE_APPLICATION_NAME;
